import React from 'react';
import { assignTextMessageToApplication } from '../Data/TextMessageData';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import {useDispatch, useSelector} from 'react-redux';
import {SET_LOADING, ApplicationDispatch} from '../store/application/types';
import IconButton from '@mui/material/IconButton';
import {useConfiguration} from "../Data/ConfigurationData";
import {Constants} from "../utils/constants";
import { AppState } from '../store/rootReducer';
import ApplicationQueue from "./Views/ApplicationQueues/ApplicationQueue/ApplicationQueue";
export interface ApplicationPickerProps {
  textMessageId: number;
}

export const ApplicationPicker: React.FC<ApplicationPickerProps> = (props) => {
  const dispatch = useDispatch<ApplicationDispatch>();
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const { data: configuration } = useConfiguration();
  const applicationQueues = useSelector((state: AppState) => state.applications.lookups.applicationQueues);
  const applicationQueueDetails = useSelector((state: AppState) => state.applications.applicationQueueDetails);
  
  const allQueue = applicationQueues.find(aq => aq.id === Constants.applicationQueues.all);
  
  return (
    <>
    <IconButton size="small" onClick={() => {
      setIsDialogOpen(true);
    }}>
      <AssignmentIcon />
    </IconButton>
    <Dialog
      fullWidth
      maxWidth="xl"
      open={isDialogOpen}
      onClose={() => setIsDialogOpen(false)}
      PaperProps={{
        style: {
          minHeight: '80vh',
          maxHeight: '80vh',
        }
      }}
    >
      <DialogTitle>Select Application</DialogTitle>
      <DialogContent>
        {configuration && allQueue &&
          <ApplicationQueue
            applicationQueueLoadingDetail={applicationQueueDetails.find(aqd => aqd.id === allQueue.id)!}
            applicationQueue={allQueue}
            defaultStatus=""
            onSelect={async (appId) => {
              try {
                dispatch({type: SET_LOADING, payload: true});
                await assignTextMessageToApplication(props.textMessageId, appId);
                setIsDialogOpen(false);
              } finally {
                dispatch({type: SET_LOADING, payload: false});
              }
            }}
            configuration={configuration}
          />
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setIsDialogOpen(false)} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
}
